export function formatDate(timestamp:any) {
  const d = new Date(timestamp);
  const time = d.toLocaleTimeString("en-US");
  return time.substr(0, 5) + time.slice(-2) + " | " + d.toLocaleDateString();
}
type formatQuestionParams = { author:any, option1:any, option2:any, questionId:any }
export function formatQuestion({ author, option1, option2, questionId }:formatQuestionParams) {
  const res = {
    id: questionId,
    author,
    timestamp: Date.now(),
    optionOne: {
      votes: [],
      text: option1,
    },
    optionTwo: {
      votes: [],
      text: option2,
    },
  };
  return res;
}
